import { createSelector } from '@reduxjs/toolkit'

import { getUserConfig as getRootConfig } from '../root.selectors'

const getConfigSlice = (state) => getRootConfig(state).config

export const getUserConfig = createSelector(getConfigSlice, (config) => config.user || {})
export const getSystemConfig = createSelector(getConfigSlice, (config) => config.system || {})

export const getUserID = createSelector(getUserConfig, (config) => config.ID)

export const getPasswordRules = (userID?: number | string) =>
  createSelector(
    getUserID,
    (state) => getRootConfig(state).passwordRules,
    (currentUserID, passwordRules) => passwordRules[userID || currentUserID],
  )
